<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="['+7 ### ###-##-##']"
          label="Контактный телефон"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import {
  getValidationErrorText,
  EMAIL,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  INN,
  PERSON_NAME,
} from '@/utils/validate';

export const personModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  inn: '',
  snils: '',
  email: '',
  phone: '',
};

export const personValidation = {
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN(12),
  },
  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  phone: {
    minLength: minLength(16),
  },
};

export default {
  name: 'Person',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
